import image1 from '../../assets/images/slider_img2.jpg';
import image2 from '../../assets/images/slider_img1.jpg';
import image3 from '../../assets/images/slider_img3.jpg';
import image4 from '../../assets/images/slider_img4.jpg';
const content = [
	{
		title: 'Vulputate Mollis Ultricies',
		description:'Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Fusce dapibus, tellus ac cursus commodo..',
		button: 'Read More',
		image: image1,
		user: 'Daniel',
		userProfile: 'https://s7.postimg.cc/abavelo3v/1_3x.png',
	},
	{
		title: 'Tortor Dapibus',
		description:
			'Nullam id dolor id nibh ultricies vehicula ut id elit. Cras mattis consectetur purus sit amet fermentum. Morbi leo risus..',
		button: 'Discover',
		image: image2,
		user: 'Samantha',
		userProfile: 'https://s7.postimg.cc/ujy8zz7vv/5_3x.png',
	},
	{
		title: 'Phasellus volutpat metus',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras mattis consectetur purus sit amet fermentum.',
		button: 'Buy now',
		image: image3,
		user: 'Michael',
		userProfile: 'https://s7.postimg.cc/6exjimijv/3_3x.png',
	},
	{
		title: 'Ultricies Vulputate Mollis',
		description:
			'Aenean eu leo quam. Pellentesque ornare sem lacinia  nibh, ut fermentum massa justo sit amet risus. ',
		button: 'Read More',
		image: image4,
		user: 'Jessica',
		userProfile: 'https://s7.postimg.cc/7ihnu80ij/4_3x.png',
	},
	{
		title: 'Odo Aenean Quam Tortor',
		description:
			'Nullam id dolor id nibh ultricies vehicula ut id elit. Cras mattis consectetur Lorem ipsum dolor sit amet,',
		button: 'Discover',
		image: image1,
		user: 'William',
		userProfile: 'https://s7.postimg.cc/f9ydt4zmj/2_3x.png',
	},
	{
		title: 'Volutpat Aenean metus',
		description:
			'quam venenatis vestibulum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentumconsectetur.',
		button: 'Buy now',
		image: image2,
		user: 'Katerina',
		userProfile: 'https://s7.postimg.cc/hsk2th5tn/6_3x.png',
	},
]
export default content;